<template>
    <div class="animated fadeIn master-page">
        <!-- Top Filter Card -->
        <div class="filter-card mb-4">
            <h4 class="card-title mb-3">Serah Terima Gadai Lunas</h4>
            <div class="filter-row d-flex flex-wrap align-items-center gap-2">
                <div class="filter-item filter-select-box">
                    <multiselect
                        name="filterCabang"
                        v-model="input.cabang" 
                        :options="cabangOption" 
                        :internal-search="true"
                        :allow-empty="true"
                        deselect-label=""
                        select-label=""
                        label="name"
                        track-by="name"
                        placeholder="Cabang"
                        class="custom-multiselect"
                    />
                </div>
                <div class="filter-item filter-tipe-box">
                    <b-form-select v-model="input.tipe" name="tipePinjaman" :options="tipeOption" value-field="id" text-field="name" class="form-control-custom"></b-form-select>
                </div>
                <div class="filter-item filter-input-box">
                    <b-form-input 
                        v-model="input.tanggal" 
                        name="tanggal"
                        type="date"
                        :max="maxDate"
                        placeholder="Tanggal"
                        class="form-control-custom"
                        @keyup.enter="onFilter"
                    ></b-form-input>
                </div>
                <button 
                    type="button" 
                    class="btn btn-search-icon btn-search-text" 
                    :disabled="isBusy" 
                    @click="onFilter" 
                    name="searchBtn"
                > 
                    <i class="fa fa-search mr-2"></i>Tampilkan Laporan
                </button>
                <button 
                    type="button" 
                    class="btn btn-outline-reset" 
                    :disabled="isBusy" 
                    @click="onReset" 
                    name="resetBtn"
                >
                    Reset
                </button>
            </div>
        </div>

        <!-- Table Card -->
        <div class="table-card">
            <b-table 
                hover 
                show-empty 
                :busy="isBusy"
                :items="paginatedData" 
                :fields="fields"
                responsive 
                class="custom-table mb-3"
            >
                <template v-slot:table-busy>
                    <div class="text-center my-4 py-3">
                        <b-spinner class="align-middle text-success mb-2"></b-spinner>
                        <p class="mb-0 text-muted small">Memuat data serah terima gadai lunas...</p>
                    </div>
                </template>

                <template v-slot:empty>
                    <div class="text-center py-4 text-muted">
                        Tidak ada data serah terima gadai lunas.
                    </div>
                </template>

                <!-- NO. FAKTUR -->
                <template v-slot:cell(noFaktur)="row">
                    <span class="faktur-text">{{ getNoFaktur(row.item) }}</span>
                </template>

                <!-- ANGGOTA -->
                <template v-slot:cell(anggota)="row">
                    <div class="primary-text">{{ getNamaAnggota(row.item) }}</div>
                    <div class="sub-text">{{ getNoAnggota(row.item) }}</div>
                </template>

                <!-- BARANG -->
                <template v-slot:cell(barang)="row">
                    <div class="primary-text">{{ getJenisBarang(row.item) }}</div>
                    <div class="sub-text">{{ getDetailBarang(row.item) }}</div>
                </template>

                <!-- TOTAL PELUNASAN -->
                <template v-slot:cell(totalPelunasan)="row">
                    <span class="pinjaman-text">{{ formatRupiah(getTotalPelunasan(row.item)) }}</span>
                </template>

                <!-- KASIR -->
                <template v-slot:cell(kasir)="row">
                    <span class="kasir-text">{{ getKasir(row.item) }}</span>
                </template>
            </b-table>

            <!-- Pagination Row -->
            <div class="table-pagination-row d-flex flex-wrap align-items-center justify-content-between pt-2">
                <div class="d-flex align-items-center mb-2 mb-md-0">
                    <span class="mr-2 pagination-label">Tampilkan</span>
                    <b-form-select 
                        v-model="perPage" 
                        :options="options" 
                        class="form-control-custom select-per-page mr-3"
                        @change="currentPage = 1"
                    ></b-form-select>
                    <span class="pagination-info text-muted">{{ paginationInfo }}</span>
                </div>
                <div>
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        class="custom-pagination mb-0"
                        prev-text="‹"
                        next-text="›"
                        first-number
                        last-number
                    ></b-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'serah-terima-gadai-lunas',
    data(){
        return{
            isBusy: false,
            input: {
                cabang: null,
                tanggal: null,
                tipe: null
            },
            cabangOption: [],
            tipeOption: [],
            dataSerahTerimaLunas: [],
            currentPage: 1,
            perPage: 10,
            options: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 50, text: '50' },
                { value: 100, text: '100' }
            ],
            fields: [
                { key: "noFaktur", label: "NO. FAKTUR", class: "align-middle" },
                { key: "anggota", label: "ANGGOTA", class: "align-middle" },
                { key: "barang", label: "BARANG", class: "align-middle" },
                { key: "totalPelunasan", label: "TOTAL PELUNASAN", class: "align-middle" },
                { key: "kasir", label: "KASIR", class: "align-middle" }
            ],
            maxDate: null
        }
    }, 
    computed: {
        totalRows() {
            return this.dataSerahTerimaLunas.length
        },
        paginatedData() {
            if (!this.dataSerahTerimaLunas || this.dataSerahTerimaLunas.length === 0) return []
            let start = (this.currentPage - 1) * this.perPage
            let end = start + this.perPage
            return this.dataSerahTerimaLunas.slice(start, end)
        },
        paginationInfo() {
            if (this.totalRows === 0) return 'Menampilkan 0 data'
            let from = (this.currentPage - 1) * this.perPage + 1
            let to = Math.min(this.currentPage * this.perPage, this.totalRows)
            return `Menampilkan ${from} - ${to} dari ${this.totalRows} data`
        }
    },
    methods: {

        // Tipe pinjaman mengikuti master (jenis_pinjaman), bukan daftar tetap
        loadTipePinjaman(){
            return this.$axios.get("tipe-pinjaman/selection").then(response => {
                this.tipeOption = response.data
                if (!this.input.tipe && this.tipeOption.length > 0) this.input.tipe = this.tipeOption[0].id
            }).catch(() => {})
        },


        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.cabangOption = this.$helper.getAllCabang()
            if (!this.cabangOption || this.cabangOption.length === 0) {
                this.$axios.get("cabang/all-selection").then(response => {
                    this.cabangOption = response.data
                }).catch(() => {})
            }

            let date = new Date().toISOString().slice(0, 10)
            this.input.tanggal = date
            
            let today = new Date();
            let dd = today.getDate();
            let mm = today.getMonth() + 1;
            let yyyy = today.getFullYear();
            if (dd < 10) dd = '0' + dd
            if (mm < 10) mm = '0' + mm

            this.maxDate = `${yyyy}-${mm}-${dd}`

            // Default cabang jika ada
            let userCabangId = this.$helper.getCabangId()
            if (userCabangId && this.cabangOption && this.cabangOption.length > 0) {
                let found = this.cabangOption.find(c => c.id == userCabangId)
                if (found) this.input.cabang = found
            }

            this.loadTipePinjaman().then(() => this.fetchData())
        },

        //----------------- Ambil Data Serah Terima Gadai Lunas -----------------

        fetchData() {
            this.isBusy = true
            let cabangId = this.input.cabang ? (this.input.cabang.id !== undefined ? this.input.cabang.id : this.input.cabang) : (this.$helper.getCabangId() || 1)
            let tanggal = this.input.tanggal || new Date().toISOString().slice(0, 10)
            let jenisPinjaman = this.input.tipe
            if (!jenisPinjaman) {
                this.dataSerahTerima = []
                this.isBusy = false
                return
            }

            // Sesuai parameter backend: cabangId, tanggal, jenisPinjaman tanpa trailing slash sebelum ?
            let query = `?cabangId=${cabangId}&tanggal=${tanggal}&jenisPinjaman=${jenisPinjaman}`

            this.$axios.get("laporan-cabang-harian/serah-terima-gadai-lunas" + query)
                .then(response => {
                    if (Array.isArray(response.data)) {
                        this.dataSerahTerimaLunas = response.data
                    } else if (response.data && Array.isArray(response.data.data)) {
                        this.dataSerahTerimaLunas = response.data.data
                    } else if (response.data && Array.isArray(response.data.list)) {
                        this.dataSerahTerimaLunas = response.data.list
                    } else {
                        this.dataSerahTerimaLunas = []
                    }
                })
                .catch(error => {
                    console.log(error)
                    this.dataSerahTerimaLunas = []
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isBusy = false
                })
        },

        onFilter() {
            this.currentPage = 1
            this.fetchData()
        },

        onReset() {
            this.input.cabang = null
            let userCabangId = this.$helper.getCabangId()
            if (userCabangId && this.cabangOption && this.cabangOption.length > 0) {
                let found = this.cabangOption.find(c => c.id == userCabangId)
                if (found) this.input.cabang = found
            }
            let date = new Date().toISOString().slice(0, 10)
            this.input.tanggal = date
            this.input.tipe = this.tipeOption.length ? this.tipeOption[0].id : null
            this.currentPage = 1
            this.fetchData()
        },

        //----------------- Helper Format Data Tabel -----------------

        getNoFaktur(item) {
            return item.noFaktur || item.faktur || item.noSbg || item.fakturNo || '-'
        },

        getNamaAnggota(item) {
            return item.namaAnggota || item.nama || item.anggota || item.customerName || item.member || '-'
        },

        getNoAnggota(item) {
            return item.noAnggota || item.nomorAnggota || item.kodeAnggota || item.memberCode || item.noIdentitas || ''
        },

        getJenisBarang(item) {
            return item.jenis || item.jenisBarang || item.kategori || item.tipeBarang || '-'
        },

        getDetailBarang(item) {
            if (item.merk || item.tipe) {
                return [item.merk, item.tipe].filter(Boolean).join(' - ')
            }
            return item.deskripsiBarang || item.namaBarang || item.itemDetail || ''
        },

        getTotalPelunasan(item) {
            return item.totalPelunasan !== undefined ? item.totalPelunasan : (item.nilaiPelunasan || item.nominalPelunasan || item.pelunasan || item.nilaiPinjaman || item.pinjaman || 0)
        },

        getKasir(item) {
            return item.kasir || item.namaKasir || item.creator || item.petugas || item.user || '-'
        },

        formatRupiah(val) {
            if (val === null || val === undefined || isNaN(Number(val))) return 'Rp. 0'
            return `Rp. ${this.$helper.addThousandSeparator(val)}`
        }
    },

    created(){
        this.init()
    }
}
</script>

<style lang="scss" scoped>
$deep-pine: #023831;
$deep-pine-hover: #034d43;
$gold-accent: #C69B6B;
$ink-heading: #1B2E28;
$ink-body: #32433D;
$ink-muted: #8C9F98;
$input-border: #D8E0DC;
$card-border: #E8ECE9;

.master-page {
    padding: 0 4px 24px;
}

// Top Filter Card
.filter-card {
    background: #FFFFFF;
    border-radius: 14px;
    box-shadow: 0 2px 12px rgba(2, 56, 49, 0.05);
    border: 1px solid $card-border;
    padding: 20px 24px;
}

.card-title {
    font-size: 18px;
    font-weight: 700;
    color: $ink-heading;
    letter-spacing: -0.01em;
}

.filter-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.filter-input-box {
    width: 200px;
}

.filter-select-box {
    flex: 1 1 260px;
    min-width: 200px;
}

.form-control-custom {
    height: 38px;
    border-radius: 8px;
    border: 1px solid $input-border;
    font-size: 13px;
    color: $ink-body;
    padding: 6px 12px;
    background-color: #FFFFFF;
    transition: all 0.2s ease;

    &:focus {
        border-color: $deep-pine;
        box-shadow: 0 0 0 2px rgba(2, 56, 49, 0.1);
        outline: none;
    }
}

.custom-multiselect {
    min-height: 38px;

    ::v-deep {
        .multiselect__tags {
            min-height: 38px;
            border-radius: 8px;
            border: 1px solid $input-border;
            padding: 7px 36px 0 12px;
            background: #FFFFFF;
            transition: all 0.2s ease;
        }

        .multiselect__placeholder {
            margin-bottom: 0;
            padding-top: 0;
            color: #8C9F98;
            font-size: 13px;
        }

        .multiselect__single {
            margin-bottom: 0;
            padding-top: 0;
            font-size: 13px;
            color: $ink-body;
            line-height: 22px;
        }

        .multiselect__select {
            height: 36px;
            width: 32px;
            padding: 4px 6px;
        }

        &.multiselect--active .multiselect__tags {
            border-color: $deep-pine;
            box-shadow: 0 0 0 2px rgba(2, 56, 49, 0.1);
        }
    }
}

.filter-tipe-box {
    width: 190px;
}

.btn-search-icon.btn-search-text {
    width: auto;
    padding: 0 18px;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
}

.btn-search-icon {
    background-color: $deep-pine;
    border: none;
    color: #FFFFFF;
    width: 42px;
    height: 38px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
        background-color: $deep-pine-hover;
        color: #FFFFFF;
        box-shadow: 0 2px 8px rgba(2, 56, 49, 0.15);
    }
}

.btn-outline-reset {
    background: #FFFFFF;
    border: 1px solid #BAC9C2;
    color: #4B605A;
    font-size: 13px;
    font-weight: 500;
    padding: 0 18px;
    height: 38px;
    border-radius: 8px;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
        background: #F4F7F5;
        border-color: #8C9F98;
        color: #1B2E28;
    }
}

// Table Card
.table-card {
    background: #FFFFFF;
    border-radius: 14px;
    box-shadow: 0 2px 12px rgba(2, 56, 49, 0.05);
    border: 1px solid $card-border;
    padding: 20px 24px;
}

.custom-table {
    ::v-deep {
        thead th {
            background-color: #FAFCFA;
            color: #7E928B;
            font-size: 11.5px;
            font-weight: 700;
            letter-spacing: 0.03em;
            text-transform: uppercase;
            border-top: none;
            border-bottom: 1px solid #E5ECE8;
            padding: 14px 16px;
        }

        tbody td {
            font-size: 13px;
            color: $ink-body;
            padding: 14px 16px;
            border-top: 1px solid #F0F4F2;
            vertical-align: middle;
        }

        tbody tr:hover {
            background-color: #F8FAF9;
        }
    }
}

.faktur-text {
    font-weight: 600;
    color: #1B2E28;
    letter-spacing: 0.01em;
}

.primary-text {
    font-weight: 600;
    color: #1B2E28;
    line-height: 1.3;
}

.sub-text {
    font-size: 11.5px;
    color: #8C9F98;
    margin-top: 2px;
}

.pinjaman-text {
    font-weight: 600;
    color: #1B2E28;
}

.kasir-text {
    font-weight: 600;
    color: #1B2E28;
}

// Table Pagination
.table-pagination-row {
    border-top: 1px solid #F0F4F2;
    padding-top: 14px;
}

.pagination-label, .pagination-info {
    font-size: 12.5px;
    color: #556B64;
}

.select-per-page {
    width: 65px;
    height: 32px;
    padding: 2px 6px;
    font-size: 12px;
}

// Custom Pagination Component
::v-deep .custom-pagination {
    .page-item {
        margin: 0 2px;

        .page-link {
            border-radius: 6px;
            border: 1px solid #D8E0DC;
            color: #4B605A;
            font-size: 12.5px;
            font-weight: 500;
            padding: 4px 10px;
            min-width: 32px;
            text-align: center;

            &:hover {
                background-color: #F4F7F5;
                color: #1B2E28;
            }
        }

        &.active .page-link {
            background-color: $deep-pine;
            border-color: $deep-pine;
            color: #FFFFFF;
        }

        &.disabled .page-link {
            border-color: #E8ECE9;
            color: #BAC9C2;
            background-color: #FFFFFF;
        }
    }
}
</style>
